import { gql } from 'graphql.macro';

export const requestInvoiceBatchOrdersExportTemplate = gql`
    mutation requestInvoiceBatchOrdersExport($id: MongoDbObjectId!) {
        requestInvoiceBatchOrdersExport(id: $id)
    }
`;
